import { cva } from 'class-variance-authority'

export const dotIndicatorVariants = cva('block rounded-full', {
    variants: {
        variant: {
            default: 'bg-cta',
            error: 'bg-error-core',
            warning: 'bg-warning-core',
            missing: 'bg-missing-core',
            success: 'bg-success-inverse',
        },
        size: {
            sm: 'w-2 h-2',
            md: 'w-3 h-3',
        },
        disabled: { true: 'bg-disabled-inverse' },
    },
    defaultVariants: {
        variant: 'default',
        size: 'md',
        disabled: false,
    },
})

export const numberIndicatorVariants = cva('w-fit flex items-center justify-center rounded-full ', {
    variants: {
        variant: {
            default: '',
            error: '',
            warning: '',
            missing: '',
            success: '',
        },
        disabled: { true: '' },
        outline: { true: '' },
        size: {
            sm: 'h-4 px-1 paragraph-2xs-medium',
            md: 'h-5 px-2 paragraph-xs-medium',
        },
    },
    defaultVariants: {
        variant: 'default',
        disabled: false,
        outline: false,
        size: 'sm',
    },
    compoundVariants: [
        // Solid variants
        { variant: 'default', outline: false, class: 'bg-cta text-primary-inverse' },
        { variant: 'error', outline: false, class: 'bg-error-inverse text-primary-inverse' },
        { variant: 'warning', outline: false, class: 'bg-warning-inverse text-primary-inverse' },
        { variant: 'missing', outline: false, class: 'bg-missing-inverse text-primary-inverse' },
        { variant: 'success', outline: false, class: 'bg-success-inverse text-primary-inverse' },
        { disabled: true, outline: false, class: 'bg-disabled-inverse text-primary-inverse' },

        // Outline variants
        { variant: 'default', outline: true, class: 'bg-default text-default' },
        { variant: 'error', outline: true, class: 'bg-error text-error-secondary' },
        { variant: 'warning', outline: true, class: 'bg-warning text-warning-secondary' },
        { variant: 'missing', outline: true, class: 'bg-missing text-missing-secondary' },
        { variant: 'success', outline: true, class: 'bg-success text-success-secondary' },
        { disabled: true, outline: true, class: 'bg-disabled text-disabled-secondary' },
    ],
})
